import ls from '@/helpers/localStorage'

export const dateTag = (data) => {
  // Get translations from local storage, avoids circular import for i18n store.
  const tag = data.data?.DateTag
  const i18n = ls.get('translations-en')
  if (!i18n) return tag
  return i18n[tag] || tag
}
